module.exports = __webpack_public_path__ + "img/55.65b8ac6d.svg";